<template>
	<section>
    <div class="bg">
      <img class="bg-image" src="../assets/icon/bg_forget.jpg">
      <div class="logo">
        <img src="../assets/icon/logo.png" @click="returnLogin()" alt="L">
      </div>
      <el-form v-if="!token" 
               :model="ruleForm" 
               :rules="rules" 
               ref="ruleForm" 
               label-position="left" 
               label-width="0px" 
               class="demo-ruleForm bg-container">
        <div v-if="!isSend">
          <h3 class="title">忘記密碼 ?</h3>
          <h4 class="hint">請輸入您的電子郵件地址以重設密碼。</h4>
          <el-form-item prop="checkEmail">
            <el-input type="email" 
                      v-model="ruleForm.checkEmail"
                      @keyup.enter.native="handleSubmit" 
                      auto-complete="off" 
                      placeholder="電子郵件">
            </el-input>
          </el-form-item>
          <el-form-item style="width:100%;">
            <el-button  type="primary" 
                        style="width:100%; margin-top: 20px;" 
                        @click.native.prevent="handleSubmit" 
                        :loading="loading">送出
            </el-button>
          </el-form-item>
        </div>
        <div v-else>
          <h3 class="title">更改密碼</h3>
          <h4 class="hint">{{message}}</h4>
          <el-form-item>
            <el-button type="info" 
                       style="width:100px; float: right; margin-top: 20px; margin-bottom: -20px;" 
                       @click.native.prevent="returnLogin()">回首頁
            </el-button>
          </el-form-item>
        </div> 
      </el-form>
      <el-form v-show="checkToken"
               v-else 
               :model="ruleForm2" 
               :rules="rules2" 
               ref="ruleForm2"
               label-position="left" 
               label-width="0px" 
               class="demo-ruleForm bg-container">
        <div v-if="changeStatus === 0">
          <h3 class="title">更改密碼</h3>
          <div class="hint">新的密碼</div>
          <el-form-item prop="newPwd">
            <el-input :type="showPass ? 'text' : 'password'"  
                      v-model="ruleForm2.newPwd" 
                      @keyup.enter.native="handleSubmitPwd" 
                      auto-complete="off" 
                      placeholder="請輸入您要更改的新密碼">
            </el-input>
            <img :title="showPass? '顯示密碼': '隱藏密碼'" 
                  @click="showPass=!showPass" 
                  style="position: absolute; width: 20px; height: 20px; right: 1rem; top: 0.5rem; cursor: pointer;"
                  :src="showPass?openeye:nopeneye">
          </el-form-item>
          <div class="hint">再輸入一次</div>
          <el-form-item prop="checkPwd">
            <el-input :type="showPass2 ? 'text' : 'password'"  
                      v-model="ruleForm2.checkPwd" 
                      @keyup.enter.native="handleSubmitPwd" 
                      auto-complete="off" 
                      placeholder="請再一次輸入，以便確認">
            </el-input>
            <img :title="showPass2? '顯示密碼': '隱藏密碼'" 
                  @click="showPass2=!showPass2" 
                  style="position: absolute; width: 20px; height: 20px; right: 1rem; top: 0.5rem; cursor: pointer;"
                  :src="showPass2?openeye:nopeneye">
          </el-form-item>
          <el-form-item style="width:100%;">
            <el-button  type="primary" 
                        style="width:100%; margin-top: 20px; margin-bottom: -20px;" 
                        @click.native.prevent="handleSubmitPwd" 
                        :loading="loading">更改
            </el-button>
          </el-form-item>
        </div>
        <div v-else-if="changeStatus === 1">
          <h3 class="title">更改密碼</h3>
          <h4 class="hint">密碼更改完成，您現在可使用新的密碼登入。</h4>
          <el-form-item>
            <el-button  type="primary"
                        style="width:100px; float: right; margin-top: 20px; margin-bottom: -20px;" 
                        @click.native.prevent="returnLogin()">登入
            </el-button>
          </el-form-item>
        </div> 
        <div v-else>
          <h3 class="title">發生錯誤</h3>
          <h4 class="hint">連結已失效，如果還需要更改密碼，請點選下面更改密碼按鈕。</h4>
          <el-form-item>
            <el-button  type="danger" 
                        style="width:100px; float: right; margin-top: 20px; margin-bottom: -20px;" 
                        @click.native.prevent="returnForgetPwd()">更改密碼
            </el-button>
          </el-form-item>
        </div> 
      </el-form>
    </div>
  </section>
</template>

<script>
  import { forgetPassword, changePwdWithToken, verifyWithToken } from '../api/api';
  export default {
    data() {
      return {
        openeye: require('@/assets/icon/ic_eye.png'), 
        nopeneye: require('@/assets/icon/ic_remove_eye.png'),
        showPass: false,
        showPass2: false,
        loading: false,
        checkToken: false,
        token: null,
        ruleForm: {
          checkEmail: ''
        },
        ruleForm2: {
          newPwd:'',
          checkPwd: ''
        },
        isSend: false,
        changeStatus: 0, //0: 變更中, 1: 成功, 2: 失敗 
        message: '',
        rules: {
          checkEmail: [
            {
              required: true,//是否必填
              message: '請輸入電子郵件',//错误提示信息
              trigger: 'blur'//检验方式（blur为鼠标点击其他地方，）
            },
            {
              type: 'email',//要检验的类型（number，email，date等）
              message: '請輸入正確的電子郵件格式',
              trigger: 'blur'
            }
          ]
        },
        rules2: {
          newPwd: [
            {
              required: true,//是否必填
              message: '新密碼不能為空',//错误提示信息
              trigger: 'blur'//检验方式（blur为鼠标点击其他地方，）
            }
          ],
          checkPwd: [
            {
              required: true,//是否必填
              message: '確認新密碼不能為空',//错误提示信息
              trigger: 'blur'//检验方式（blur为鼠标点击其他地方，）
            }
          ],
        },              
      };
    },
    created() {
      document.onkeydown = function() { 
        if (window.event) { 
          if (event.keyCode == 13 && event.srcElement.type == "email") { 
            window.event.preventDefault();
          }
        } 
      } ;
      this.isSend = false;
      if(location.hash.split('/').length > 2) {
        this.token = location.hash.split('/')[2].split('&')[0];
      }
    },
    mounted() {
      
    },
    beforeCreate() {
      if(location.hash.split('/').length > 2) {
        this.token = location.hash.split('/')[2].split('&')[0];
      }
      var sendParams = { token: this.token};
      this.checkToken = false;
      //call forget Password
      verifyWithToken(sendParams).then((response) => {
        this.checkToken = true;
        let { code, info } = response;
        if(code === 200) {
          this.changeStatus = 0; 
        } else if(code === 404) {
          this.changeStatus = 2; 
        } else {
          this.changeStatus = 2; 
          this.$message({
            message: info,
            type: 'error'
          });
        }
      }).catch(function (error) {
        this.checkToken = true;
        //變更失敗
        this.$message({
          message: error.response.data.info,
          type: 'error'
        });
      });	
    },
    methods: {
      returnLogin() {
        this.$router.push({ path: '/login' });
      },
      returnForgetPwd() {
        this.$router.push({ path: '/forgetPwd' });
        window.location.reload();
      },
      handleSubmit() {
        let _this = this;
        _this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            _this.loading = true;
            var sendParams = { email: _this.ruleForm.checkEmail};
            //call forget Password
            forgetPassword(sendParams).then((response) => {
              _this.loading = false;
              _this.isSend = true; 
              let { code, info } = response;
              if(code === 200) {
                _this.message = "密碼變更步驟已向 " + _this.ruleForm.checkEmail + " 寄出，有些位址送達需時，建議您於5分鐘後到信箱查看。"
              } else {
                _this.message = info + "  ＊請聯絡系統管理員，謝謝。"
              }
            }).catch(function (error) {
              _this.loading = false;
              _this.$message({
                message: error.response.data.info,
                type: 'error'
              });
  	        });	
          } else {
            return false;
          }
        });
      },
      handleSubmitPwd() {
        let _this = this;
        _this.$refs.ruleForm2.validate((valid) => {
          if (valid) {
            //判斷密碼是否有一致
            if(_this.ruleForm2.newPwd !== _this.ruleForm2.checkPwd) {
              _this.$message({
                message: '輸入的密碼需一致',
                type: 'error'
              });
              return;
            }

            //進行中
            _this.loading = true;
            var sendParams = { 
              pwd: {
                newpasswd: _this.ruleForm2.checkPwd
              },
              token: _this.token
            };
            //call forget Password
            changePwdWithToken(sendParams).then((response) => {
            //變更成功
              _this.loading = false;
              let { code, info } = response;
              if(code === 200) {
                _this.changeStatus = 1; 
              } else if(code === 404) {
                _this.changeStatus = 2; 
              } else {
                _this.$message({
                  message: info,
                  type: 'error'
                });
              }
            }).catch(function (error) {
            //變更失敗
              _this.loading = false;  
              _this.$message({
                message: error.response.data.info,
                type: 'error'
              });
            });
          } else {
            return false;
          }
        }); 
      }
    }
  }
</script>

<style lang="scss" scoped>
.bg {
  .bg-image {
    background-size: cover;
    background-repeat:no-repeat;
    width: 100%;
    height: 100%;
    object-fit:cover;
    position: fixed;
  }
  .logo {
    display: inline-block;
    vertical-align: middle;
    height: 100%;
    color: #FFF;
    margin-top: 16px;
    margin-left: 70px;
    cursor: pointer;
    /*width: 70%;*/
    position: relative;
    background-size: cover;
  }
  .bg-container {
    position: relative;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    vertical-align: middle;
    margin: 12% auto;
    background-clip: padding-box;
    width: 462px;
    padding: 35px 35px 25px 35px;
    background: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 4px 1px rgba(0,0,0,0.39);
    .title {
      font-size: 18px;
      line-height: 25px; 
      font-weight: 500;
      text-align: left;
      color: #1D2327;
    }
    .hint {
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 3px;  
      font-weight: 500;
      text-align: left;
      color: #1D2327;
    }
  }
}
</style>


// WEBPACK FOOTER //
// ForgetPWD.vue?87a902f6